import { CONFIRM_ID } from './types';
import type { CardStatus, TimelineEntry } from './types';

/**
 * A timeline entry's visual card status, resolved purely from the LIVE deploy cursor —
 * the strip renders the WHOLE timeline, so every card computes its own state by index:
 *  - the leading edge (`index === cursor - 1`) is "in progress" (while still deploying);
 *  - earlier entries have settled to their final state (completed/failed/skipped);
 *  - later entries have not run yet — "pending";
 *  - the synthetic confirmation card is "pending" while deploying (the parent keeps it
 *    out of the rendered list until then) and celebrates as "confirm" once done.
 *
 * @param index  0-based position of the entry in the FULL timeline
 * @param cursor live leading edge (1..length); === length once done
 * @param done   the deploy has finished (all real steps settled, confirm celebrates)
 */
export const statusFor = (entry: TimelineEntry, index: number, cursor: number, done: boolean): CardStatus => {
  if (entry.id === CONFIRM_ID) return done ? 'confirm' : 'pending';
  if (!done && index === cursor - 1) return 'in-progress';
  if (!done && index >= cursor) return 'pending';
  return entry.settledState === 'confirm' ? 'confirm' : entry.settledState;
};

export default statusFor;
